const monthsAbb: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const timestampToPostDate = (timestamp: number): string => {
  const date = new Date(timestamp);
  return `${monthsAbb[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`
};
